/* eslint-disable react/no-children-prop */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/jsx-indent */

import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import local from 'services/localization/local';
import { Button, ErrorSection, LoadingIcon } from 'shared';
import { TextField } from 'shared/form-fields';
import * as validators from 'services/fields/field-validators';
import './signIn.scss';
import { getAuthConnection, resetConnection, loading } from 'auth-connections/auth-connection-actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { signIn } from '../../identity/action-creators';
import { authConnection } from 'auth-connections/auth-connection-selectors';

export class SignInForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showPassword: false,
      showEmailConfirmModal:this.props.unverifiedEmail && this.props.accessToken,
      email: this.props.email
    };

    this.showOrHidePassword = this.showOrHidePassword.bind(this);
    this.reset = this.reset.bind(this);
    this.redirectToAuth0 = this.redirectToAuth0.bind(this);
    this.checkConnection = this.checkConnection.bind(this);
    this.closeEmailConfirmModal=this.closeEmailConfirmModal.bind(this);
  }

  componentDidMount() {
    this.reset();
  }

  componentWillUnmount() {
    const { change, untouch } = this.props;
    change('password', null);
    untouch('password');
  }

  showOrHidePassword() {
    this.setState({
      showPassword: this.state.showPassword ? false : true
    });
  }

  checkConnection(event) {
    const { actions } = this.props;
    if (event && event.email && event.email.length > 0) {
      this.setState({ email: event.email });
      const domain = event.email.substring(event.email.lastIndexOf('@') + 1);
      actions.getAuthConnection(domain);
    }
  }

  redirectToAuth0(event) {
    const { actions } = this.props;
    actions.signIn(event.email, event.password);
  }

  reset() {
    const { actions } = this.props;
    actions.resetConnection();
  }

  closeEmailConfirmModal(){
    this.setState({
      showEmailConfirmModal: this.state.showEmailConfirmModal ? false : true
    });
  }


  render() {
    const { handleSubmit, signingIn, submitting, pristine, errorMessage, privacyPolicySection, authConnection, actions,email } = this.props;
    const isSigningIn = signingIn || submitting;
    const isDisabled = (email ? ( email.length > 0 ? false : true) : pristine || signingIn || authConnection.loading);
    var icon = <i className={this.state.showPassword ? 'fa fa-eye fa-eye-slash eye-slash-icon' : 'fa fa-fw fa-eye eye-icon'} onClick={this.showOrHidePassword}></i>;
    if (authConnection && authConnection.connection && authConnection.connection.length > 0) {
      actions.signIn(this.state.email, null, authConnection.connection);
    }
    return (
      <form id="signin-form" onSubmit={handleSubmit(authConnection.connectionNotFound ? this.redirectToAuth0 : this.checkConnection)} >
        <ErrorSection>{errorMessage}</ErrorSection>
        <div className='edit-inputType-wrapper'>
          <Field
            label={local.formEmailLabel}
            name="email"
            type="email"
            autoComplete="username email"
            component={TextField}
            disabled={authConnection.connectionNotFound}
            validate={[validators.required, validators.email]} />
          {authConnection.connectionNotFound &&
            <Button
              id="editButton"
              onClick={this.reset}
              color="transparent"
              className="edit-inputType-btn">
              {local.edit}
            </Button>}
        </div>
        {authConnection.loading && <LoadingIcon />}
        {(authConnection.connectionNotFound) && <Field
          label={local.formPasswordLabel}
          name="password"
          component={TextField}
          type={this.state.showPassword ? 'text' : 'password'}
          autoComplete="current-password"
          disabled={isSigningIn}
          validate={[validators.required]}
          children={icon} />}
        <br />

        <Button
          id="signInAuth0Button"
          submit
          color="blue"
          disabled={isDisabled}
          className="w-100 mb-4">
          {local.continue}
        </Button>
        <br />
        {privacyPolicySection}
      </form>
    );
  }
}

SignInForm.propTypes = {
  signingIn: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  privacyPolicySection: PropTypes.node.isRequired,
  // redux form
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  change: PropTypes.func.isRequired,
  untouch: PropTypes.func.isRequired
};
function mapDispatchToProps(dispatch) {
  const actions = { getAuthConnection, signIn, resetConnection, loading };
  return { actions: bindActionCreators(actions, dispatch) };
}

const mapStateToProps = state => ({
  unverifiedEmail:state.identity.unverifiedEmail,
  email:state.identity.email,
  authConnection: authConnection(state)
});

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
  form: 'signin-register-reset',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true
})(SignInForm));
